export enum ChatType {
  CHAT = 'chat',
  MESSAGE_HUB = 'message-hub',
  FORUM = 'forum',
}
